/* Important Info component for the Cast Info info */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";

const CastDeleteRep = () => {

  return (
   <div>
    <Row className="my-3">
    <Col md={{span: 10, offset: 1}}>
    <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
    <p className={`${styles.Red} text-center mt-3`}>REPLACING / REMOVING ACTORS</p>
    <hr className={`mt-2 mb-0`}/>
    <p className={`pt-2`}>
    <span className={`${styles.Red}`}>Replace</span>:</p>
    <p className={`pt-2`}>
    <span className={`${styles.Red}`}>*</span> In Manage Users delete the old Actor and register the new Actor.</p>
    <p className={`pt-2`}>
    <span className={`${styles.Red}`}>*</span> On the Character Edit page replace the old Actor's details with the new Actor's.
  </p>
  <p className={`pt-4`}>
    <span className={`${styles.Red}`}>Remove</span>:</p>
    <p className={`pt-2`}>
    <span className={`${styles.Red}`}>*</span> Delete the Actor in Manage Users.</p>
    <p className={`pt-2`}>
    <span className={`${styles.Red}`}>*</span> Delete the Actor's details on the Character Edit page.<br/>    
    This is done simply by deleting the info in the inputs boxes so they are blank and 
    submitting the form.
  </p>
  <hr className={`mt-2 mb-0`}/>
  </div> 
  </Col>
  </Row>
  </div>
)
}

export default CastDeleteRep 